import { createSlice } from "@reduxjs/toolkit";
import {createPaymentAction, fetchPaymentStatus, fetchPriceApparat} from '../actions/paymentsActions'

const initialState = {
    payments: [],
    priceApparat: null,
    loadingPayment: false,
    error: null,
    // Тело последнего запроса на создание платежа. Нужно, чтобы экран оплаты
    // мог перевыпустить QR, когда картинка не пришла: отдельного эндпоинта
    // «дай QR по этому платежу» на бэкенде нет, единственный способ —
    // повторить POST /api/v1/payments/create с тем же payload.
    lastPaymentRequest: null,
    // Результат опроса GET /payments/status (PaymentPage.jsx, раз в 3с, пока
    // не пришёл терминальный статус). null — опрос ещё не начался/не ответил
    // ни разу; не путать с paymentStatus.status === "pending".
    paymentStatus: null,
    };

const paymentsReducer = createSlice({
    name: "payments",
    initialState,
    reducers: {},
        extraReducers: builder => {
            builder
                .addCase(createPaymentAction.pending, (state, action) => {
                    state.loadingPayment = true
                    state.error = null
                    state.lastPaymentRequest = action.meta.arg
                })
                .addCase(createPaymentAction.fulfilled, (state, action) => {
                    state.loadingPayment = false
                    state.payments = action.payload
                    // Новый заказ (в т.ч. переизданный тот же order_id при
                    // антиспам-переиспользовании на бэкенде) — статус
                    // предыдущего опроса больше не про этот платёж.
                    state.paymentStatus = null
                })
                .addCase(createPaymentAction.rejected, (state, action) => {
                    state.loadingPayment = false
                    state.error = action.payload
                })
                .addCase(fetchPaymentStatus.fulfilled, (state, action) => {
                    state.paymentStatus = action.payload
                })
                // .rejected намеренно не обрабатываем: одиночный сетевой сбой
                // опроса не должен затирать последний известный статус и
                // перекрашивать экран — следующий тик (3с) попробует снова.
                .addCase(fetchPriceApparat.pending, state => {
                    state.loadingPayment = true
                    state.error = null
                })
                .addCase(fetchPriceApparat.fulfilled, (state, action) => {
                    state.loadingPayment = false
                    state.priceApparat = action.payload 
                })
                .addCase(fetchPriceApparat.rejected, (state, action) => {
                    state.loadingPayment = false
                    state.error = action.payload
                })
        },
});


export const {
    fetchPaymentsStart,
    fetchPaymentsSuccess,
    fetchPaymentsFailure,
    createPaymentStart,
    createPaymentSuccess,
    createPaymentFailure,
    fetchPriceApparatStart,
    fetchPriceApparatSuccess,
    fetchPriceApparatFailure
} = paymentsReducer.actions;
export default paymentsReducer.reducer;